import {allVesselFields} from 'components/forms/vessel/fields';
import {isObject} from 'lodash';
import get from 'lodash.get';
import set from 'lodash.set';

const vesselFields = Object.keys(allVesselFields);

const removeVesselFields = data => {
    if (isObject(data)) {
        const outData = {};
        Object.entries(data).forEach(([key, value]) => {
            if (!vesselFields.includes(key)) {
                outData[key] = value;
            }
        });
        return outData;
    } else {
        return {};
    }
};

// designed to remove vessel data from the active form
const clearVessel = (root, loopNode) => {
    return (state, payload) => {
        const data = loopNode
            ? get(state.forms[root], loopNode)
            : state.forms[root];
        const cleanState = removeVesselFields(data);
        const newState = {...cleanState, ...payload};
        if (loopNode) {
            const stateCopy = JSON.parse(JSON.stringify(state));
            set(stateCopy, `forms[${root}].${loopNode}`, newState);
            return stateCopy;
        } else {
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [root]: {...newState, ...payload},
                },
            };
        }
    };
};

export default clearVessel;
